import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsRowingNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M8.53 31.04l4.65-8.74h.99l.87-1.65h-.99l1.03-1.93-.94-1.76-1.96 3.69h-.97l-.88 1.65h.98l-4.65 8.74zM21.94.17L19.5 4.83a9.067 9.067 0 00-1.02 3.57 3.25 3.25 0 00-.02.44l-1.54 2.9.94 1.75 1.92-3.61c.21-.02.43-.04.64-.08a6.49 6.49 0 004.7-3.48L28.25.17zm1.71 5.4a4.862 4.862 0 01-3.5 2.6 7.614 7.614 0 01.81-2.58l1.97-3.76h2.63z" />
        <path d="M6.88 6.32a6.489 6.489 0 004.41 3.42c.306.072.617.119.93.14l3.05 5.72v.01l2.68 5.04h-.99l.87 1.65h.99l4.65 8.74h1.87l-4.65-8.74h.98l-.88-1.65h-.97l-2.16-4.06v-.01l-4.11-7.71c0-.01-.01-.01-.01-.02a2.17 2.17 0 00-.01-.26 8.953 8.953 0 00-1.03-3.76L10.06.17H3.75zm4.16-.73c.422.805.696 1.679.81 2.58a4.863 4.863 0 01-3.5-2.6L6.44 1.83h2.63z" />
      </g>
    </svg>
  )
);
SvgSportsRowingNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsRowingNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsRowingNormalMedium;
